import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { NostrProvider } from './hooks/useNostr';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <NostrProvider>
      <App />
    </NostrProvider>
  </React.StrictMode>
);
